var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newAlbum"},[_c('h1',[_vm._v(_vm._s(_vm.$t('home.newAlbum')))]),_c('div',{staticClass:"playlist-row"},[_c('div',{staticClass:"playlists"},[_c('CoverRow',{attrs:{"type":"album","items":_vm.albums,"sub-text":"artist","show-play-button":true}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }